import script from "./SelectAlarm.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectAlarm.vue?vue&type=script&setup=true&lang=js"

import "./SelectAlarm.vue?vue&type=style&index=0&id=c990a768&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c990a768"]])

export default __exports__